export default "assets/images/logo-af2d91af.png";